/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-promise-reject-errors */
// API request usign Axios library

import axios from 'axios'
import Cookies from 'js-cookie'

let gController = null; // global
let targetController = {};
export default {
  install(Vue, options) {
    const apiEndpoint = options.config.VUE_APP_API_LINK;

    Vue.prototype.$XHR = {
      // POST API request
      post(payload) {
        return new Promise((resolve, reject) => {
          const bodyFormData = new FormData()

          for (const e in payload) {
            if (Object.prototype.hasOwnProperty.call(payload, e)) {
              bodyFormData.append(e, payload[e])
            }
          }

          const config = {
            method: 'post',
            url: apiEndpoint,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' },
          }

          axios(config).then(response => {
            // handle server response
            if (response.data !== undefined && response.data.status !== undefined) {
              if (response.data.status !== undefined && response.data.result !== undefined) {
                if (response.data.status === 'success') {
                  resolve(response.data.result);
                } else {
                  reject({
                    "result": "fail",
                    "data": response.data.result
                  });
                }
              } else if (response.data.result !== undefined && response.data.data !== undefined) {
                if (response.data.result === 'success') {
                  resolve(response.data.data);
                } else {
                  reject({
                    "result": "fail",
                    "data": response.data.data
                  });
                }
              } else {
                console.error('[API] POST failed (non-successful result)')
                reject({
                  "result": "fail",
                  "data": response.data
                });
              }
            } else {
              console.error('[API] POST failed (missing data or result)')
              reject({
                "result": "fail",
                "data": "message.errorOccur"
              })
            }

          }).catch(response => {
            // handle error
            console.error('[API] POST failed (connection exception)')
            reject({
              "result": "fail",
              "data": "message.errorOccur"
            })
          })
        })
      },

      async get(url) {
        try {
          const response = await axios.get(url);
          // The JSON data is automatically parsed and available in response.data
          return Promise.resolve(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
          return Promise.reject(null);
        }
      },

      async extraPost(url) {
          console.log(url)
        try {
          // const response = await axios.post(url);
          let config = {};
          const response = await axios.post(url);
          // console.log(response)
          return Promise.resolve(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
          return Promise.reject(null);
        }
      },

      async api(key, passObj) {
        try {
          let controllerName = '';
          let _obj = { ...passObj };
          if (_obj['controller_name'] !== undefined) {
            if (_obj['controller_name'] !== null && _obj['controller_name'] !== '') {
              controllerName = _obj['controller_name'];
            }

            delete _obj['controller_name'];
          }

          const getUserCookies = Cookies.get(`${options.config.VUE_APP_RUN_MODE}_CMS_LID`);
          if (getUserCookies) {
            const getUser = JSON.parse(getUserCookies);
            if (getUser && getUser.id && getUser.id > -1) {
              if (getUser.user_type === 'student') {
                _obj['curr_student'] = getUser.id;
              } else {
                _obj['curr_staff'] = getUser.id;
              }
            }
          }

          const params = new URLSearchParams();
          params.set(key, JSON.stringify(_obj));

          let config = {};
          if (controllerName && targetController[controllerName]) {
            config.signal = targetController[controllerName].signal
          } else if (gController) {
            config.signal = gController.signal
          }
          const response = await axios.post(apiEndpoint, params.toString(), config);

          const result = response.data;
          if (result.status === 'success' || result.result === 'success') {
            let data = null;
            if (result.status === 'success') {
              data = result.result;
            } else {
              data = result.data;
            }
            if (result.total !== undefined && result.total !== null && result.total !== '') {
              return Promise.resolve({ data: data, total: result.total });
            }

            if (key === 'get_student_quote' && result.count !== undefined && result.count !== null && result.count !== '') {
              return Promise.resolve({ data: data, total: result.count });
            }

            return Promise.resolve(data);

          } else if ((result.status === 'fail' && result.result) || (result.result === 'fail' && result.data)) {
            let data = null;
            if (result.status === 'fail') {
              data = result.result;
            } else {
              data = result.data;
            }

            return Promise.reject({
              "result": "fail",
              "data": typeof data === 'string' ? data.trim() : JSON.stringify(data)
            })
          } else if (key === 'get_general_setting') {
            if (result.logo !== undefined && result.custom_text !== undefined) {
              return Promise.resolve(result);
            }
          }

          return Promise.reject({
            "result": "404",
            "data": "message.errorOccur"
          })
        } catch (err) {
          if (err && err.message === "canceled") {
            return Promise.reject({
              "result": "fail",
              "data": "abort"
            })
          } else {
            console.error('[API] POST failed (connection exception)')
            return Promise.reject({
              "result": "fail",
              "data": "message.errorOccur"
            })
          }
        }
      },

      upload(payload, uploadProgress = null) {
        return new Promise((resolve, reject) => {
          const bodyFormData = new FormData()

          for (const e in payload) {
            if (Object.prototype.hasOwnProperty.call(payload, e)) {
              bodyFormData.append(e, payload[e])
            }
          }

          let config = {
            method: 'post',
            url: 'https://uploader.innpressionhost.com/request.php',
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' },
          }

          if (uploadProgress != null) {
            config.onUploadProgress = uploadProgress
          }

          axios(config).then(response => {
            // handle server response
            if (response.data !== undefined && Array.isArray(response.data) && response.data.length > 0) {
              if (response.data[0]) {
                if (response.data[1] && response.data[1].filename) {
                  resolve(response.data[1].filename);
                } else {
                  console.error('[API] POST failed (missing data or result)')
                  reject({
                    "result": "fail",
                    "data": "message.errorOccur"
                  })
                }
              } else {
                console.error('[API] POST failed (non-successful result)')
                reject({
                  "result": "fail",
                  "data": response.data[1]
                });
              }
            } else {
              throw null;
            }
          }).catch(response => {
            // handle error
            console.error('[API] POST failed (connection exception)')
            reject({
              "result": "fail",
              "data": "message.errorOccur"
            })
          })
        })
      },

      serverTime() {
        const now = new Date()
        const utcMs = Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours(),
          now.getUTCMinutes(),
          now.getUTCSeconds()
        )
        const plus8 = new Date(utcMs + 8 * 60 * 60 * 1000)
        const s = plus8.toISOString()
        const tempServerTime = `${s.substring(0, 19)}Z`;

        return new Promise((resolve, reject) => {
          let config = {
            method: 'post',
            url: apiEndpoint.replace('request.php', 'server_time.php'),
            data: new FormData(),
            headers: { 'Content-Type': 'multipart/form-data' },
          }

          axios(config).then(response => {
            // handle server response
            if (response.data !== undefined && response.data.status !== undefined) {
              if (response.data.status !== undefined && response.data.result !== undefined) {
                if (response.data.status === 'success') {
                  resolve(response.data.result);
                  return;
                }
              }
            }

            console.error('[API] GET SERVER TIME (NULL)')
            resolve(tempServerTime);

          }).catch(response => {
            // handle error
            console.error('[API] POST failed (connection exception)')
            resolve(tempServerTime);
          })
        })
      },

      abort(controllerName = '') {
        if (controllerName) {
          if (targetController[controllerName]) {
            targetController[controllerName].abort();
            targetController[controllerName] = null;
            if (options.config.VUE_APP_RUN_MODE === 'DEV') {
              console.log(`************************** XHR abort: ${controllerName} **************************`);
            }
          }
        } else {
          // abort all
          if (gController) {
            gController.abort();
            gController = null;
            if (options.config.VUE_APP_RUN_MODE === 'DEV') {
              console.log('************************** XHR abort **************************');
            }
          }

          for (let key in targetController) {
            if (targetController[key]) {

              targetController[key].abort();
              targetController[key] = null;
              if (options.config.VUE_APP_RUN_MODE === 'DEV') {
                console.log(`************************** XHR abort: ${key} **************************`);
              }
            }
          }
          targetController = {};
        }
      },
      restart(controllerName = '') {
        if (controllerName) {
          if (!targetController[controllerName]) {
            if (options.config.VUE_APP_RUN_MODE === 'DEV') {
              console.log(`************************** XHR Restart: ${controllerName} **************************`);
            }
            targetController[controllerName] = new AbortController();
          }
        } else if (!gController) {
          if (options.config.VUE_APP_RUN_MODE === 'DEV') {
            console.log('************************** XHR Restart **************************');
          }
          gController = new AbortController();
        }
      }
    }
  },
}
